/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimTask } from './ClaimTask';
import {
    ClaimTaskFromJSON,
    ClaimTaskFromJSONTyped,
    ClaimTaskToJSON,
    ClaimTaskToJSONTyped,
} from './ClaimTask';

/**
 * List of tasks for a claim
 * @export
 * @interface ClaimTaskListResponse
 */
export interface ClaimTaskListResponse {
    /**
     * 
     * @type {Array<ClaimTask>}
     * @memberof ClaimTaskListResponse
     */
    items: Array<ClaimTask>;
}

/**
 * Check if a given object implements the ClaimTaskListResponse interface.
 */
export function instanceOfClaimTaskListResponse(value: object): value is ClaimTaskListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClaimTaskListResponseFromJSON(json: any): ClaimTaskListResponse {
    return ClaimTaskListResponseFromJSONTyped(json, false);
}

export function ClaimTaskListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTaskListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClaimTaskFromJSON)),
    };
}

export function ClaimTaskListResponseToJSON(json: any): ClaimTaskListResponse {
    return ClaimTaskListResponseToJSONTyped(json, false);
}

export function ClaimTaskListResponseToJSONTyped(value?: ClaimTaskListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClaimTaskToJSON)),
    };
}

